<template>
  <div
      class="logo-placeholder"
      @click="toggleImageUploader"
      :style="{'background-image': 'url(' + imageSrc + ')'}"
  >
    <input
        hidden
        ref="imageUploader"
        type="file"
        accept="image/*"
        @change="uploadImage"
    />
    <div
        class="d-flex justify-content-center align-items-center text-uppercase position-absolute w-100"
        style="background-color: rgba(0,151,244,0.75);height: 32.3px;bottom: 0;"
    >
      Edit
    </div>
    <div class="overlay-logo"></div>
  </div>
</template>

<script>
export default {
  props: ['imageSrc'],

  methods: {
    toggleImageUploader () {
      this.$refs['imageUploader'].click();
    },

    uploadImage (event) {
      this.$emit(
          'imageUploaded',
          event.target.files[0],
          window.URL.createObjectURL(event.target.files[0]),
      );
    },
  },
};
</script>

<style scoped lang="scss">
.logo-placeholder {
  border: 1px solid #d5d5d5;
  border-radius: 50%;
  height: 136px;
  width: 136px;
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 17px;
  text-align: center;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.overlay-logo {
  background-color: #d5d5d5;
  opacity: 0;
  width: 100%;
  height: 100%;

  &:hover {
    opacity: 0.2;
  }
}
</style>

